/*
 * @Author: Shusheng
 * @Date: 2024-08-18 10:29:23
 * @LastEditors: Shusheng
 * @Description: 差异化，是否展示配置，非通用功能
 * 当有一天某个功能都为true的时候，代表该功能为通用功能，需要将代码逻辑层删除，为通用化
 */
import { isXwsy, isXwx, isXwyk } from '../env';
/**
 * survey:学情记录是否展示学员详情页重要动态
 * timingSms:定时短信是否展示定时发送
 * level:等级体系在学员详情页是否展示
 * showCallTreasure: 是否展示外呼宝
 * detailPerformanceType: 学员详情页课程表现类型是否自定义
 * buyRecordConfig: 购课链接标记
 * showTemplate: 企微模版
 * showRenewalTemplate：预约链接模版
 * redirectToNewClass: 重定向链接是体验新模式
 */

const XwxConfig = {
  survey: false,
  timingSms: true,
  level: true,
  showCallTreasure: true,
  detailPerformanceType: true,
  buyRecordConfig: false,
  showTemplate: true,
  showRenewalTemplate: true,
  redirectToNewClass: true
};

const XwsyConfig = {
  survey: false,
  timingSms: true,
  level: false,
  showCallTreasure: false,
  detailPerformanceType: true,
  buyRecordConfig: false,
  showTemplate: false,
  showRenewalTemplate: false,
  redirectToNewClass: false
};

const XwykConfig = {
  survey: true,
  timingSms: false,
  level: true,
  showCallTreasure: false,
  detailPerformanceType: true,
  buyRecordConfig: true,
  showTemplate: true,
  showRenewalTemplate: false,
  redirectToNewClass: false
};

const getConfig = () => {
  if (isXwx) {
    return XwxConfig;
  }
  if (isXwsy) {
    return XwsyConfig;
  }
  if (isXwyk) {
    return XwykConfig;
  }
  return XwxConfig;
};

export const brandDiffConfig = getConfig();
